import {dbComun} from '../bases-datos'

export const ObtenerConceptosDeAptitud = async () => {
  return Promise.resolve(dbComun.table('ConceptoDeAptitud').toArray())
}
